import { pipe } from 'ramda';
import * as R from 'ramda';
import { parseISO, parse, format } from 'date-fns/fp';

export const dateFormat = pipe(parseISO, format('yyyy-MM-dd'));

const formatTime = R.pipe(parse(new Date(), 'HH:mm:ssx'), format('HH:mm'));

export const getDuration = ({ start_time, end_time }) => {
  if (!start_time || !end_time) return null;
  return {
    startTime: formatTime(start_time),
    endTime: formatTime(end_time),
  };
};
